let disconnectFn: (() => Promise<void>) | null = null;

export function registerAuctionUserHubLifecycle(fn: () => Promise<void>) {
    disconnectFn = fn;
}

export function unregisterAuctionUserHubLifecycle(fn: () => Promise<void>) {
    if (disconnectFn === fn)
        disconnectFn = null;
}

export async function disconnectAuctionUserHub(): Promise<void> {
    if (!disconnectFn)
        return;

    await disconnectFn();
}
